(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eightoon-wp-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      window.addEventListener('load', () => {
        this.setHeaderHeight();
      });
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;

      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.header.classList.contains('menu-open')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-pt01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const mvImgAnime = document.querySelector('.mv-img-anime');
    const mvTextAnimes = document.querySelectorAll('.mv-text-anime');
    const modalWindow = document.getElementById('modal-window-area');
    const modalClose = document.getElementById('modal-close');
    const modalBG = document.getElementById('modal-bg');

    function showMvContent() {
      if (mvImgAnime) {
        mvImgAnime.classList.add('fadeIn');
      }

      mvTextAnimes.forEach((mvTextAnime) => {
        mvTextAnime.classList.add('fadeIn');
      });
    }

    function openModal() {
      if (!modalWindow || !modalBG) return;

      if (window.innerWidth >= 300 && !modalWindow.classList.contains('active')) {
        modalWindow.classList.add('active');
        modalBG.classList.add('active');
      }
    }

    function closeModal() {
      if (!modalWindow) return;

      modalWindow.classList.add('active2');
      document.body.classList.add('active');

      setTimeout(function() {
        modalWindow.classList.remove('active');
        modalWindow.classList.remove('active2');
        document.body.classList.remove('active');
      }, 300);
    }

    // ローディング画面を削除したため、MVは読み込み完了を待たずに即時フェード表示します。
    showMvContent();

    // 旧ローディング完了後の待機時間を削除し、ポップアップのみ短い遅延で表示します。
    setTimeout(openModal, 1000);

    window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
        showMvContent();
      }
    }, false);

    if (modalBG) {
      modalBG.addEventListener('click', closeModal);
    }

    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }

    const splideOptions = {
      type: "loop",
      arrows: false,
      autoplay: true,
      rewind: true,
      perPage: 1,
      gap: 0,
      updateOnMove: true,
      pauseOnHover: false,
      interval: 8000,
      speed: 1000,
      pagination: true,
      classes: {
        page: "mv-pagenation"
      }
    };

    if (window.innerWidth >= 1024) {
      const splide = new Splide("#mv-splide", splideOptions);

      splide.on('pagination:mounted', function(data) {
        data.items.forEach(function(item, index) {
          item.button.textContent = index + 1;
          const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          svg.setAttribute("viewBox", "0 0 200 200");
          svg.setAttribute("width", "30");
          svg.setAttribute("height", "30");
          svg.classList.add("circle-wrapper-sp");

          const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
          circle.setAttribute("cx", "100");
          circle.setAttribute("cy", "100");
          circle.setAttribute("r", "50");
          circle.setAttribute("stroke", "currentColor");
          circle.setAttribute("stroke-width", "7");
          circle.setAttribute("fill", "none");
          circle.classList.add("circle-animation");

          svg.appendChild(circle);
          item.button.appendChild(svg);

          item.button.addEventListener('click', function() {
            splide.go(item.page);
            splide.Components.Autoplay.play();
          });
        });
      });

      splide.mount();
    } else {
      const splide = new Splide("#mv-splide", splideOptions);

      splide.on('pagination:mounted', function(data) {
        data.items.forEach(function(item, index) {
          item.button.textContent = index + 1;
        });
      });

      splide.mount();
    }

    const topTextSlider = new Splide('#top-text-slider', {
      mediaQuery: 'min',
      gap: 32,
      type: 'loop',
      arrows: false,
      drag: false,
      flickPower: 300,
      pagination: false,
      autoScroll: {
        speed: 0.5,
        pauseOnHover: false,
        pauseOnFocus: false
      },
      breakpoints: {
        1025: {
          gap: 90
        }
      }
    });

    topTextSlider.mount(window.splide.Extensions);
  });

  const objectsFi = document.querySelectorAll('.fi');

  const cbFi = function(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fadeIn');
        observer.unobserve(entry.target);
      }
    });
  }

  const options = {
    root: null,
    rootMargin: "-30px",
    threshold: 0
  }

  const ioFi = new IntersectionObserver(cbFi, options);

  objectsFi.forEach(objectFi => {
    ioFi.observe(objectFi);
  });

  function setHeaderSize() {
    const header = document.querySelector("header");

    if (!header) return;

    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }

  window.addEventListener('resize', setHeaderSize);

  setHeaderSize();

  } catch(e) { console.error(e); }
})();
})();
